import {useLocation, useParams, useSearchParams} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {Button, Typography} from "@mui/material";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import CircularProgress from "@mui/material/CircularProgress";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import VariablesTable from "../../../components/UI/table/customer-detales/processing/VariablesTable";
import {VariablesFilterData} from "../../../data/FilterTables/VariablesFilterData";
import CompositionController from "../../../API/organization/CompositionController";
import DependentModulesTable from "./DependentModulesTable";
import {flattenModuleCompositionRow} from "../../../utils/flattenModuleCompositionRow";
import {enrichModuleCompositionRows} from "../../../utils/enrichModuleCompositionRows";
import {asArray} from "../../../utils/asArray";
import {pickKitchenCompositionId, rememberKitchenCompositionId} from "../../../utils/withCompositionIdQuery";

const initValidation = {
    name: "",
}

const resolveTab = (savedTab) => {
    const tab = Number(savedTab)
    if (tab === 2 || tab === 6) {
        return 2
    }
    if (tab === 3 || tab === 4) {
        return 3
    }
    return 1
}

const DependentModuleCompositionItem = () => {
    const ComponentVariablesWithFilter = useMemo(() => {
        return withFilter(VariablesTable, VariablesFilterData);
    }, []);
    const params = useParams();
    const pathname = useLocation().pathname
    const [searchParams] = useSearchParams()
    const compositionIdFromQuery = searchParams.get("compositionId")
    const compositionNameFromQuery = searchParams.get("compositionName") ?? ""
    const tabStoragePath = `/organization/dependent-module-composition/${params.id}`
    const [isLoading, setIsLoading] = useState(true)

    const [data, setData] = useState({
        id: null,
        name: "",
        patternW: null,
        patternD: null,
        patternH: null,
        dependModules: [],
        dependentModuleCompositionId: null,
        compositionId: compositionIdFromQuery,
    });
    const [validationState, setValidationState] = useState(initValidation)
    const [moduleName, setModuleName] = useState("")
    const [variables, setVariables] = useState([])
    const [alertData, setAlertData] = useState({});
    const [tab, setTab] = useState(() => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const savedTab = pagesData[tabStoragePath]?.tab ?? pagesData[pathname]?.tab
        return resolveTab(savedTab)
    });
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        if (typeof nextState === "function") {
            setTableOptions((prev) => {
                const resolved = nextState(prev)
                if (resolved?.pageSize != null && resolved.pageSize !== prev.pageSize) {
                    EditLocalStoragePagesData(tabStoragePath, "pageSize", resolved.pageSize)
                }
                return resolved
            })
            return
        }
        setTableOptions(nextState)
        if (nextState?.pageSize != null && nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(tabStoragePath, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const savedTab = pagesData[tabStoragePath]?.tab ?? pagesData[pathname]?.tab ?? 1

        return {savedTab: resolveTab(savedTab)}
    }

    useEffect(() => {
        rememberKitchenCompositionId(compositionIdFromQuery)
    }, [compositionIdFromQuery])

    useEffect(() => {
        const {savedTab} = getStartPageSize()
        setTab(savedTab)
        CompositionController.getDependentModuleCompositionById(params.id).then(async function (response) {
            const raw = response.data && typeof response.data === "object" ? response.data : {}
            const moduleCompositions = await enrichModuleCompositionRows(
                asArray(raw.moduleCompositions).map(flattenModuleCompositionRow)
            )
            const compositionId = pickKitchenCompositionId(compositionIdFromQuery, raw)
            rememberKitchenCompositionId(compositionId)
            setData({
                id: raw.id,
                name: raw.name ?? "",
                patternW: raw.patternW ?? null,
                patternH: raw.patternH ?? null,
                patternD: raw.patternD ?? null,
                dependentModuleCompositionId: raw.id,
                compositionId,
                dependModules: moduleCompositions,
            })
            setModuleName(raw.name ?? "")
            setVariables(asArray(raw.variablesMap))
            setTab(savedTab)
            if (savedTab === 2) {
                tableOptionsHandle((prev) => ({
                    ...prev,
                    totalElements: asArray(raw.variablesMap).length,
                }))
            }
            if (savedTab === 3) {
                tableOptionsHandle((prev) => ({
                    ...prev,
                    totalElements: moduleCompositions.length,
                }))
            }
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => {
                setIsLoading(false)
            })
    }, [params.id, compositionIdFromQuery]);

    const handleChangeTab = (nextTab) => {
        EditLocalStoragePagesData(tabStoragePath, "tab", nextTab)
        setTab(nextTab)
        tableOptionsHandle((prev) => ({
            ...prev,
            totalElements: nextTab === 2
                ? asArray(variables).length
                : nextTab === 3
                    ? asArray(data.dependModules).length
                    : prev.totalElements
        }))
    }

    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleValidationData = () => {
        const newErrors = {
            name: data?.name ? "" : "пустое поле"
        }
        setValidationState(newErrors)
    }
    const setDependModules = (newData) => {
        setData(prev => ({...prev, dependModules: newData}))
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Модуль ${moduleName}`}
                path={[{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}]}/>
            <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                <Typography sx={{fontSize: "24px", fontWeight: 700}}>{`Модуль ${moduleName}`}</Typography>
                <ButtonGroupTabBar activeTab={tab}>
                    <Button tabIndex={1} onClick={() => handleChangeTab(1)}>
                        <CheckIcon/>
                        Основные
                    </Button>
                    <Button tabIndex={2} onClick={() => handleChangeTab(2)}>
                        <CheckIcon/>
                        Переменные
                    </Button>
                    <Button tabIndex={3} onClick={() => handleChangeTab(3)}>
                        <CheckIcon/>
                        Зависимые модули
                    </Button>
                </ButtonGroupTabBar>
                {isLoading ?
                    <Box sx={{
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CircularProgress disableShrink/>
                    </Box> : <>
                        {tab === 1 ? <Box sx={{width: "400px"}}>
                            <TextFieldValidation
                                name={"name"}
                                type={"text"}
                                value={data?.name}
                                label={"Наименование"}
                                setCurrValues={setData}
                                validationError={validationState?.name}
                                setValidationState={setValidationState}
                            />
                            <TextFieldValidation
                                name={"patternW"}
                                type={"text"}
                                value={data?.patternW}
                                label={"Паттерн ширины"}
                                setCurrValues={setData}
                                required={false}
                            />
                            <TextFieldValidation
                                name={"patternD"}
                                type={"text"}
                                value={data?.patternD}
                                label={"Паттерн глубины"}
                                setCurrValues={setData}
                                required={false}
                            />
                            <TextFieldValidation
                                name={"patternH"}
                                type={"text"}
                                value={data?.patternH}
                                label={"Паттерн высоты"}
                                setCurrValues={setData}
                                required={false}
                            />
                            <Box sx={{
                                width: 400,
                                paddingTop: "20px",
                                display: "flex",
                                justifyContent: "flex-end"
                            }}>
                                <ButtonAdd text={"Применить"} onClick={handleValidationData}/>
                            </Box>
                        </Box> : tab === 2 ?
                            <ComponentVariablesWithFilter
                                data={variables}
                                setData={setVariables}
                                enableEditing={true}
                                tableOptions={tableOptions}
                                tableOptionsHandle={tableOptionsHandle}
                                moduleId={data.id}
                            /> :
                            <DependentModulesTable
                                data={data.dependModules}
                                setData={setDependModules}
                                dependentModuleCompositionId={data.dependentModuleCompositionId ?? params.id}
                                compositionId={pickKitchenCompositionId(compositionIdFromQuery, data.compositionId)}
                                compositionName={compositionNameFromQuery}
                                handleModalAlert={handleModalAlert}
                            />}
                    </>}
            </Box>
            <ModalAlert
                data={alertData}
                onClose={handleCloseAlert}/>
        </Box>
    )
}
export default DependentModuleCompositionItem
